/*
 * @Author: vinc
 * @LastEditTime: 2020-10-26 17:50:00
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/pages/index'], resolve)
    }, {
      path: '/mall',
      name: 'Mall',
      component: resolve => require(['@/pages/mall'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js